/* eslint-env browser */
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxPromise from 'redux-promise';
import AppComponent from './containers/AppComponent';
import reducers from './reducers';
import getBanners from './getBanners';

const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);

const lang = document.querySelector('html').getAttribute('lang');
window.vacancyLang = lang;
if (window.DYCON && window.DYCON.EmplyDataObjectNames) {
  window.DYCON.EmplyDataObjectNames.forEach((o) => {
    const selector = `#${o} .vacancies-container`;
    const domElement = document.querySelector(selector);
    if (domElement) {
      window.vacancyElement = o;
      render(
        <Provider store={createStoreWithMiddleware(reducers)}>
          <AppComponent
            element={o}
            lang={lang}
          />
        </Provider>,
        domElement,
      );
    }
  });
}
getBanners(lang === 'da' ? 0 : 1);
